import React from 'react';
import './styles/App.scss';
import Header from './components/common-header/Header';
import Hero from './components/Hero/Hero';
import Intro from './components/Intro/Intro';
import Chapter1 from './components/Chapters/Chapter1';
import Chapter2 from './components/Chapters/Chapter2';
import Chapter3 from './components/Chapters/Chapter3';
import Chapter4 from './components/Chapters/Chapter4';
import Vision from './components/Chapters/Vision';
import Footer from './components/common-footer/Footer';
import Hyperlink from './components/Hyperlink/Hyperlink';
import cubeS from './assets/cube-cta.png';
import RelatedContents from './components/relatedContents/RelatedContents';

function App() {
  const hyperlinkData = [
    {
      copy: 'intel.com/stories',
      href: 'https://www.intel.com/content/www/us/en/company-overview/wonderful.html'
    }
  ];

  return (
    <main className="App">
      <Header clientName={'Intel Corporation'} />
      <Hero />
      <Intro />
      <Chapter1 />
      <Chapter2 />
      <Chapter3 />
      <Chapter4 />
      <Vision />
      <div className="cta">
        <img src={cubeS} alt="" className="cta__cubes" />
        <p>
          Find out more at <Hyperlink hyperlinkData={hyperlinkData[0]} origin="cta" />
        </p>
      </div>
      <RelatedContents />
      <Footer />
    </main>
  );
}

export default App;
